<template>
  <div class="flex-column">
    <router-view style="flex:1"></router-view>
    <copyright></copyright>
  </div>
</template>
<script>
import Copyright from '@/components/layouts/Copyright'
export default {
  name: 'NoHeaderLayout',
  components: {Copyright}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layouts/NoHeaderLayout.vue